import type { PcfPreviewDto } from "@service/product/public/dto/pcf-preview.dto";

import { ccfApiClient } from "../../../../shared/api/api-clients";
import type {
  BuyerDetailsRow,
  BuyerProductRequestOverviewRow,
  SupplierConnectionListRow,
  SupplierInvitationStatus,
  SupplierPcf,
  SupplierPcfRef,
  SupplierStats,
} from "../../public/supplier-types";

export const getSupplierStats = async (): Promise<SupplierStats> =>
  (await ccfApiClient.get<SupplierStats>("network/suppliers/stats")).data;

export const getSupplierInvitationStatus = async (): Promise<SupplierInvitationStatus> =>
  (await ccfApiClient.get<SupplierInvitationStatus>("network/suppliers/invitation-status")).data;

export const getSupplierConnections = async (): Promise<SupplierConnectionListRow[]> =>
  (await ccfApiClient.get<{ connections: SupplierConnectionListRow[] }>("network/suppliers/connections")).data
    .connections;

export const getBuyerDetails = async (connectionId: string): Promise<BuyerDetailsRow> =>
  (await ccfApiClient.get<BuyerDetailsRow>(`network/suppliers/connections/${connectionId}`)).data;

export const getSupplierProductRequestsOverview = async (): Promise<BuyerProductRequestOverviewRow[]> =>
  (await ccfApiClient.get<{ products: BuyerProductRequestOverviewRow[] }>("network/suppliers/product-requests")).data
    .products;

export const getSupplierPcfs = async (): Promise<SupplierPcf[]> =>
  (await ccfApiClient.get<{ pcfs: SupplierPcf[] }>("network/suppliers/pcfs")).data.pcfs;

export const getSupplierPcfPreview = async ({ pcfProductId, pcfVersion }: SupplierPcfRef): Promise<PcfPreviewDto> =>
  (await ccfApiClient.get<PcfPreviewDto>(`network/suppliers/pcfs/${pcfProductId}/versions/${pcfVersion}/preview`)).data;

/**
 * Binds the chosen PCF and sends it to the buyer in one call. Replaces match-pcf + submit, which
 * between them left the request bound-but-unsent — the MATCHED dead end (AIM-2740).
 */
export const submitPcf = async (productId: string, { pcfProductId, pcfVersion }: SupplierPcfRef): Promise<void> => {
  await ccfApiClient.post(`network/suppliers/products/${productId}/submit`, { pcfProductId, pcfVersion });
};
